import cloneDeep from 'lodash.clonedeep';

const dig = function (target, ...keys) {
  var digged = target;
  const [last, fn] = keys.splice(-2);

  for (const key of new Set([...keys, last, fn])) {
    if (typeof digged === 'undefined') {
      return undefined;
    }

    if (key === last && typeof fn === 'function') {
      return fn(digged, last);
    }

    if (typeof key === 'function') {
      digged = key(digged);
    } else if (typeof digged === 'object' && digged[0]) {
      digged = digged[0][key];
    } else {
      digged = digged[key];
    }
  }
  return digged;
};

export default function (data, highlights) {
  const normHighlights = Object.keys(highlights).reduce((memo, key) => {
    const normalizedKey = key.replace(/related.|ua.artwork.medias.|ua.artwork.|ua.medias.|ua.|.ref|.simple/g, '');
    memo[normalizedKey] = highlights[key];
    return memo;
  }, {});

  let element = cloneDeep(data);

  Object.keys(normHighlights).map((hKey) => {
    dig(element, ...hKey.split('.'), (objs, key) => {
      if (typeof objs === 'object' && objs.length) {
        objs.map((o) => {
          if (o[key] && o[key] === normHighlights[hKey][0].replace(/<\/?span[^>]*>/g, '')) {
            o[key] = normHighlights[hKey][0];
          }
        });
      } else {
        if (objs[key] && normHighlights[hKey].length > 0) {
          normHighlights[hKey].forEach((highlight) => {
            if (objs[key] === highlight.replace(/<\/?span[^>]*>/g, '')) {
              objs[key] = highlight;
            }
          });
        }
      }
    });
  });

  return element;
}
